<ng-container *ngIf="!!params">
    <tt-tabs ttRememberId="w_workdetails.bg_tab1" [(ttSelectedId)]="params.bg_tab1" (ttSelectedIdChange)="onTabSelected($event)">
        <tt-tab ttId="EDIT" ttIcon="far fa-edit" ttLabel="edit_custact"></tt-tab>
        <tt-tab ttId="COMMENTS" ttIcon="far fa-comments-alt" ttLabel="custact_dialog"></tt-tab>
        <tt-tab ttId="EMAIL" ttIcon="far fa-envelope" ttLabel="customersmenu_email"></tt-tab>
        <tt-tab ttId="DOCUMENTS" ttIcon="far fa-file-alt" ttLabel="documents"></tt-tab>
        <tt-tab ttId="SUBTASKS" ttIcon="far fa-tasks" ttLabel="subtasks"></tt-tab>
        <tt-tab ttId="CUSTACTMEMBERS" ttIcon="far fa-users" ttLabel="participants"></tt-tab>
        <tt-tab ttId="POWTIMES" ttIcon="far fa-clock" ttLabel="workdetails_powtimes"></tt-tab>
        <tt-tab ttId="FUNCTIONS" ttIcon="far fa-ellipsis-h" ttLabel="bg_main_functions"></tt-tab>
    </tt-tabs>
    <tt-custact-edit #edit [hidden]="params.bg_tab1 !== 'EDIT'" [params]="{ custact_no: params.custact_no, filterfield: '-', filtervalue: '-' }" (submit)="onCustactSubmit(edit)"></tt-custact-edit>
    <tt-custact-dialogs #dialogs *ngIf="params.bg_tab1 === 'COMMENTS'" [params]="{ custact_no: params.custact_no }" (submit)="onCustactSubmit(edit, dialogs)"></tt-custact-dialogs>
    <tt-email-grid
        *ngIf="emailGridLoaded"
        [hidden]="params.bg_tab1 !== 'EMAIL'"
        rememberId="workdetails_email_grid"
        argType="custact_no"
        [argValue]="params.custact_no"
        webpage="workdetails"
    ></tt-email-grid>
    <tt-documents-grid
        *ngIf="documentsGridLoaded"
        [hidden]="params.bg_tab1 !== 'DOCUMENTS'"
        rememberId="documents_grid"
        [params]="{ argtype: 'custact_no', argvalue: params.custact_no, searchtext: '', doctype: 'd', onlyFilenames: '0' }"
    ></tt-documents-grid>
    <tt-grid *ngIf="subtasksGridLoaded" [hidden]="params.bg_tab1 !== 'SUBTASKS'" [(ttOptions)]="subtasksGrid"></tt-grid>
    <tt-grid *ngIf="participantsGridLoaded" [hidden]="params.bg_tab1 !== 'CUSTACTMEMBERS'" [(ttOptions)]="participantsGrid"></tt-grid>
    <tt-powtimes-grid
        *ngIf="powtimesGridLoaded"
        [hidden]="params.bg_tab1 !== 'POWTIMES'"
        ttRememberId="workdetails_powtimes_grid"
        [params]="{ businessco_no: '99999', date_fom: '1900-01-01', date_tom: '2200-12-31', custact_no: this.params.custact_no, webpage_name: 'workdetails' }"
    ></tt-powtimes-grid>
    <div [hidden]="params.bg_tab1 !== 'FUNCTIONS'">
        <tt-card class="col-md-3 col-xs-12 p-2" ttHeading="work_details_group_register">
            <tt-work-details-register-functions [params]="params" (deleted)="navigator?.back()"></tt-work-details-register-functions>
            <tt-button-settings *ngIf="params.show_setting === '1'" ttWebpageName="workdetails"></tt-button-settings>
        </tt-card>
        <tt-card class="col-md-3 col-xs-12 p-2" ttHeading="work_details_group_plan">
            <tt-work-details-plan-functions [params]="params"></tt-work-details-plan-functions>
        </tt-card>
    </div>
</ng-container>
